<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import { DropdownMenuLabel as RekaDropdownMenuLabel } from 'reka-ui'

import '../item.css'

defineSlots<{ default(props: {}): unknown }>()
</script>

<template>
  <RekaDropdownMenuLabel class="flopui-menu-item-label">
    <slot />
  </RekaDropdownMenuLabel>
</template>
